// extracted by mini-css-extract-plugin
export default {"followingModal":"FollowingModal_followingModal__S90NQ","title":"FollowingModal_title__gsmqi","list":"FollowingModal_list__Ie0gf"};